const cities = [
  { name: "Shreveport", zips: "71101, 71103, 71104, 71105, 71106, 71107, 71108, 71109, 71115, 71118, 71119, 71129" },
  { name: "Bossier City", zips: "71110, 71111, 71112, 71113, 71171, 71172" },
  { name: "Blanchard", zips: "71009" },
  { name: "Haughton", zips: "71037" },
  { name: "Benton", zips: "71006" },
];

const benefits = [
  {
    icon: "ri-computer-line",
    title: "Start 100% Online",
    desc: "No office visit required to begin. Complete your order from your home, Barksdale housing, or office in minutes.",
  },
  {
    icon: "ri-truck-line",
    title: "Ship Your Documents",
    desc: "Use overnight shipping to send your documents directly to us — we handle every detail from there.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Expert Document Review",
    desc: "Every application is reviewed by our team before submission to reduce errors and prevent delays.",
  },
  {
    icon: "ri-calendar-check-line",
    title: "Reserved Agency Access",
    desc: "We hold reserved submission slots at the regional passport agency — no public appointment needed.",
  },
];

export default function ShreveportLocalAreaSection() {
  return (
    <section id="service-area" className="bg-white pt-6 md:pt-8 pb-20 md:pb-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Serving Shreveport, Bossier City &amp; Northwest Louisiana
          </h2>
        </div>

        <div className="max-w-4xl mx-auto mb-16">
          <div className="bg-[#F7F8FA] rounded-lg p-8 md:p-10 border border-gray-200">
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              Shreveport is the commercial and cultural hub of Northwest Louisiana, but its travel market is shaped by unique forces. Barksdale Air Force Base, one of the largest Air Force installations in the southern United States, creates a steady demand for expedited passports among military families with PCS orders, deployment rotations, and temporary duty assignments. The base's Global Strike Command sends personnel to Europe and Asia on short notice, and dependent passports must be current for most overseas assignments.
            </p>
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              The casino and gaming industry adds another dimension. Shreveport-Bossier City is Louisiana's premier casino destination, with several resorts sending employees to international gaming conferences, training programs in Macau and Singapore, and vendor meetings in Europe. The Texas proximity means many Shreveport residents commute to Dallas for business or connect through Dallas/Fort Worth International Airport for international travel — creating a travel pattern where they need passports on compressed timelines.
            </p>
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              The Red River area also hosts a significant oil and gas sector, with companies sending workers to the Middle East, West Africa, and Latin America for drilling and pipeline assignments. The city's universities — Louisiana State University Shreveport and Centenary College — send students abroad for study programs and research. And the proximity to Texas means many residents cross the state line for international flights, requiring current passports for connecting itineraries.
            </p>
            <p className="text-gray-600 text-base leading-[1.8]">
              Fast Passport Center was built for exactly these scenarios. We provide the expedited, professional passport service that Northwest Louisiana's diverse traveler base demands: dedicated agents who understand military timelines, document review that catches errors before they cost you a Barksdale deployment slot, and processing as fast as 24 hours for true emergencies. No driving to Dallas or Houston. No waiting for an appointment that may never open. Just reliable, predictable service from a registered U.S. Department of State courier.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div>
            <div className="bg-[#1A365D] rounded-lg p-7 mb-8 text-white">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
                  <i className="ri-passport-line text-[#1A365D] text-xl"></i>
                </div>
                <div>
                  <p className="font-bold text-base">Fast Passport Center — Shreveport, LA</p>
                  <p className="text-white/60 text-xs mt-0.5">Serving Shreveport, Bossier City, Barksdale AFB & Northwest Louisiana</p>
                </div>
              </div>
              <p className="text-white/70 text-sm mb-1">
                <i className="ri-map-pin-line text-[#F6C344] mr-1.5"></i>
                Remote service — no local office visit needed
              </p>
              <p className="text-white/50 text-xs mb-5 ml-5">Courier pickup available throughout Caddo and Bossier parishes</p>
              <div className="border-t border-white/10 pt-5">
                <p className="text-white/80 text-sm leading-relaxed mb-4">
                  After signing up online, choose what works best for you: <strong className="text-white">courier pickup</strong> from your home or office in most cases, <strong className="text-white">ship with our prepaid label</strong> from any UPS/FedEx location, or <strong className="text-white">schedule a drop-off</strong> at our processing center. Most clients ship overnight — no visit required.
                </p>
                <a
                  href="https://fastpassportcenter.com/checkout/"
                  className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-5 py-2.5 rounded-md transition-all whitespace-nowrap"
                >
                  Start My Passport <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {benefits.map((b, i) => (
                <div key={i} className="bg-[#F7F8FA] rounded-lg p-5 border border-gray-200">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#F6C344]/15 mb-3">
                    <i className={`${b.icon} text-[#1A365D] text-base`}></i>
                  </div>
                  <p className="font-bold text-[#1A365D] text-sm mb-1">{b.title}</p>
                  <p className="text-gray-500 text-xs leading-relaxed">{b.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div>
            <div className="bg-[#F7F8FA] rounded-lg p-7 mb-6 border border-gray-200">
              <h3 className="font-bold text-[#1A365D] text-sm uppercase tracking-wide mb-5">
                <i className="ri-map-pin-2-line text-[#F6C344] mr-2"></i>
                Communities We Serve
              </h3>
              <div className="space-y-1.5">
                {cities.map((city, i) => (
                  <div
                    key={i}
                    className="flex items-center justify-between py-2.5 px-3 bg-white rounded-md"
                  >
                    <div className="flex items-center gap-2.5">
                      <i className="ri-checkbox-circle-fill text-[#F6C344] text-sm"></i>
                      <span className="text-[#1A365D] font-medium text-sm">{city.name}</span>
                    </div>
                    {city.zips && (
                      <span className="text-gray-400 text-xs font-mono hidden sm:inline">{city.zips}</span>
                    )}
                  </div>
                ))}
              </div>
              <p className="text-gray-500 text-xs mt-4 leading-relaxed">
                Anywhere in Northwest Louisiana — start online, ship overnight, and we handle the rest. No need to drive to Dallas or Houston for regional agency appointments.
              </p>
              <div className="mt-4 pt-4 border-t border-gray-100">
                <p className="text-gray-400 text-xs font-semibold uppercase tracking-wider mb-3">Nearby Cities We Serve</p>
                <div className="flex flex-wrap gap-2">
                  {[
                    { name: "New Orleans", href: "/cities/new-orleans" },
                    { name: "Baton Rouge", href: "/cities/baton-rouge" },
                    { name: "Lafayette", href: "/states/louisiana" },
                    { name: "Monroe", href: "/states/louisiana" },
                    { name: "Lake Charles", href: "/states/louisiana" },
                    { name: "Alexandria", href: "/states/louisiana" },
                  ].map((link) => (
                    <a
                      key={link.href}
                      href={link.href}
                      className="inline-flex items-center gap-1 text-xs text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors bg-white border border-gray-200 hover:border-[#F6C344] rounded-full px-3 py-1.5 whitespace-nowrap"
                    >
                      {link.name} <i className="ri-arrow-right-line text-[10px]"></i>
                    </a>
                  ))}
                </div>
              </div>
            </div>

            <div className="bg-[#1A365D] rounded-lg p-5">
              <p className="text-white/50 text-xs uppercase tracking-widest font-semibold mb-4">Why Shreveport Travelers Choose Fast Passport Center</p>
              <div className="grid grid-cols-2 gap-3">
                {[
                  { icon: "ri-government-line", value: "Registered Courier", label: "U.S. Department of State" },
                  { icon: "ri-award-line", value: "A+ Rating", label: "Better Business Bureau" },
                  { icon: "ri-calendar-check-line", value: "20+ Years", label: "Serving Travelers Nationwide" },
                  { icon: "ri-customer-service-2-line", value: "Real Humans", label: "Live Support — Not a Bot" },
                ].map((item, i) => (
                  <a
                    key={i}
                    href="https://fastpassportcenter.com"
                    className="flex items-center gap-2.5 bg-white/5 hover:bg-white/10 rounded-md px-3 py-2.5 transition-colors cursor-pointer"
                  >
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#F6C344]/15 flex-shrink-0">
                      <i className={`${item.icon} text-sm text-[#F6C344]`}></i>
                    </div>
                    <div className="text-left">
                      <span className="text-white text-xs font-bold block leading-tight">{item.value}</span>
                      <span className="text-white/50 text-xs leading-tight block">{item.label}</span>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}